import logging, { Logger } from '../logging';

/**
 * Note that this class will not catch or log unhandled asynchronous
 * exceptions, so if you provide an async handler, make sure you have a catch
 * at the top level of your handler, otherwise the exception may be silently
 * swallowed, or in node.js, it could crash the process.
 */
export default class Signal<T extends unknown[] = []> extends Set<(...args: T) => unknown>
{
    name: string;
    log: Logger;

    constructor(name: string, category: string = 'signals') {
        super();
        this.name = name;
        this.log = logging(category);
    }

    once(handler: (...args: T) => unknown) {
        const wrapper = (...args: T) => {
            this.delete(wrapper);
            return handler(...args);
        };
        this.add(wrapper);
    }

    trigger = (...args: T) => {
        for(const handler of this) {
            try {
                handler(...args);
            } catch(error) {
                this.log.error(
                    `Error in handler for ${this.name}`, error,
                    'Handler: ', handler);
            }
        }
    }
}
